import history from 'components/MainRouter/history';

export const goToVerificationPage = () => {
  history.push('/account/verification');
};

export const goToAccountNumbersPage = () => {
  history.push('/account/profile/account-numbers');
};
